import useStorage from './useStorage';
const options = { storage: 'sessionStorage' };
const useSessionStorage = (key, initial) => useStorage(key, initial, options);
export default useSessionStorage;
